import { Flex } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { TruncatedHeader } from "../../../mantine/TruncatedHeader";
import type { GeneratorOverview } from "../../../utils/backend-types";
import { type GeneratorFeature } from "../../ComponentListContainer/ComponentList/ComponentEditWizard/Data/utils/getGeneratorFeatures";
import GeneratorFeatureSwitchCell from "./GeneratorFeatureSwitchCell";

interface getGeneratorFeatureColumnProps {
  feature: GeneratorFeature;
  variantId: number;
}

function getGeneratorFeatureColumn({
  feature,
  variantId
}: getGeneratorFeatureColumnProps): MRT_ColumnDef<GeneratorOverview> {
  return {
    accessorKey: feature.overviewKey || feature.key,
    header: feature.label,
    Header: () => (
      <Flex align="center" gap="xs">
        <feature.icon size={16} style={{ flexShrink: 0 }} />
        <TruncatedHeader>{feature.label}</TruncatedHeader>
      </Flex>
    ),
    Cell: ({ cell }) => {
      if (
        feature.generatorCondition &&
        !cell.row.original[feature.generatorCondition]
      ) {
        return null;
      }
      return (
        <GeneratorFeatureSwitchCell
          {...cell}
          feature={feature}
          variantId={variantId}
        />
      );
    },
    enableGlobalFilter: false
  };
}

export { getGeneratorFeatureColumn };
